import { render, staticRenderFns } from "./create-factory.vue?vue&type=template&id=7da44354&"
import script from "./create-factory.vue?vue&type=script&lang=ts&"
export * from "./create-factory.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports